import { combineReducers } from 'redux'
import auth from './auth'
import legend from './legend'
import measures from './measures'
import toast from './toast'
import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { backendApi } from '../apis/apiSlice'
const rootReducer = combineReducers({
  auth,
  legend,
  measures,
  toast,
  [backendApi.reducerPath]: backendApi.reducer
})

export default rootReducer
export type typeRootReducer = ReturnType<typeof rootReducer>

export const useTypedSelector: TypedUseSelectorHook<typeRootReducer> = useSelector